var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-treeview',{attrs:{"open":_vm.open,"items":_vm.items,"activatable":"","item-key":"name","open-on-click":""},scopedSlots:_vm._u([{key:"prepend",fn:function(ref){
var item = ref.item;
var open = ref.open;
var leaf = ref.leaf;
return [(!item.file)?_c('v-icon',[_vm._v("\n       "+_vm._s(open ? 'mdi-folder-open' : 'mdi-folder')+"\n     ")]):_c('v-icon',[_vm._v("\n       "+_vm._s(_vm.files[item.file])+"\n     ")])]}}]),model:{value:(_vm.tree),callback:function ($$v) {_vm.tree=$$v},expression:"tree"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ba5c3e6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/trees/WikiTree.vue
// module id = 516
// module chunks = 1